const regex = {
  default: /[^!@#$%^&*(),.?\":{}|<>_=\/;\'`~+-\[\]\\a-zA-Z0-9 ]/g,
  // alphanumeric: new RegExp(/[#@!$\\%^&*()_+|~=`{}\[\]:";<>?\/]*$/g),
  alphanumeric: /[^0-9A-Za-z `~!@#$%^&*()_+-=\]\[';/.,|}{":?><\\]+/g, // PRD
  email: new RegExp(/[,#!$\\%^&*()+|~=`{}\[\]:";<>?\/]*$/g),
  emoji: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
};

const jenisBayar = [
  {
    code: 1,
    name: "Tunai",
    type: "currency",
  },
  {
    code: 2,
    name: "Kredit",
    type: "currency",
  },
  {
    code: 3,
    name: "Debit",
    type: "currency",
  },
  {
    code: 4,
    name: "Emoney",
    type: "currency",
  },
  {
    code: 5,
    name: "Deposit",
    type: "piece",
  },
  {
    code: 6,
    name: "Paylink",
    type: "currency",
  },
  {
    code: 7,
    name: "OVO",
    type: "currency",
  },
  {
    code: 8,
    name: "DANA",
    type: "currency",
  },
  {
    code: 9,
    name: "LINKAJA",
    type: "currency",
  },
  {
    code: 10,
    name: "QRIS",
    type: "currency",
  },
  {
    code: 11,
    name: "EDC",
    type: "currency",
  },
];

const betaKeys = {
  promo: "PROMO",
  inventory: "INVENTORY",
}

const orderStatuses = [
  {
    value: '10_pickup_created',
    label: 'Pesanan Dibuat',
    bChipsColor: 'warningLightest',
  },
  {
    value: '11_first_payment_succeed',
    label: 'Pembayaran Berhasil',
  },
  {
    value: '20_waiting_expedition_courier',
    label: 'Memesan Driver Jemput',
    bChipsColor: 'warningLightest',
  },
  {
    value: '21_waiting_self_deliver',
    label: 'Menunggu Diantar',
    bChipsColor: 'blue',
  },
  {
    value: '30_waiting_outlet_courier',
    label: 'Menunggu Kurir',
    bChipsColor: 'warningLightest',
  },
  {
    value: '31_courier_otw_pickup',
    label: 'Kurir Menuju Lokasi Jemput',
    bChipsColor: 'warningLightest',
  },
  {
    value: '32_courier_otw_outlet',
    label: 'Kurir Menuju Outlet',
    bChipsColor: 'warningLightest',
  },
  {
    value: '33_reject_courier_pickup',
    label: 'Ditolak Kurir Jemput',
    bChipsColor: 'warningLightest',
  },
  {
    value: '34_failed_pickup',
    label: 'Penjemputan Gagal',
    bChipsColor: 'destructiveRedDark',
  },
  {
    value: '35_courier_accept_pickup',
    label: 'Penjemputan Diterima Kurir',
    bChipsColor: 'warningLightest',
  },
  {
    value: '36_assign_other_courier',
    label: 'kasir assign kurir lain',
    bChipsColor: 'warningLightest',
  },
  {
    value: '37_reject_order_courier',
    label: 'Menunggu Kurir',
    bChipsColor: 'warningLightest',
  },
  {
    value: '38_reject_order_self',
    label: 'Menunggu Diantar',
    bChipsColor: 'warningLightest',
  },
  {
    value: '39_reject_order_instant_courier',
    label: 'Memesan Ekspedisi Jemput',
    bChipsColor: 'warningLightest',
  },
  {
    value: '40_received_by_outlet',
    label: 'Diterima Outlet',
    bChipsColor: 'warningLightest',
  },
  {
    value: '41_waiting_payment',
    label: 'Menunggu Bayar Pesanan',
    bChipsColor: 'bronze',
  },
  {
    value: '50_transaction_created',
    label: 'Pembayaran pesanan berhasil',
    bChipsColor: 'warningLightest',
  },
  {
    value: '51_transaction_processed',
    label: 'Pesanan sedang dikemas',
    bChipsColor: 'warningLightest',
  },
  {
    value: '53_transaction_finished',
    label: 'Pesanan Selesai Dikerjakan',
    bChipsColor: 'warningLightest',
  },
  {
    value: '60_waiting_expedition_courier_delivery',
    label: 'Menunggu Driver Ekspedisi Antar',
  },
  {
    value: '61_waiting_outlet_courier_delivery',
    label: 'Menunggu Kurir Antar',
  },
  {
    value: '62_order_delivery_driver',
    label: 'Memesan Driver Antar',
  },
  {
    value: '63_received_by_courier',
    label: 'Pengantaran Diterima Kurir',
  },
  {
    value: '64_reject_courier_delivery',
    label: 'Ditolak Kurir Antar',
  },
  {
    value: '65_assign_other_courier_delivery',
    label: 'Kasir Assign Kurir Antar Lain',
  },
  {
    value: '66_reject_product_order',
    label: 'kasir menolak pesanan produk',
  },
  {
    value: '70_courier_otw_delivery_location',
    label: 'Kurir Menuju Lokasi Antar',
  },
  {
    value: '71_failed_delivery',
    label: 'Pengantaran Gagal',
  },
  {
    value: '72_received_by_customer',
    label: 'Pesanan Terkirim',
  },
  {
    value: '80_ready_to_pickup',
    label: 'Pesanan Siap Diambil',
  },
  {
    value: '81_already_pickup',
    label: 'Pesanan Telah Diambil',
  },
  {
    value: '90_canceled',
    label: 'Pesanan Dibatalkan Pelanggan',
    bChipsColor: 'red',
  },
  {
    value: '91_rejeccted',
    label: 'Pesanan Ditolak Outlet',
    bChipsColor: 'red',
  },
  {
    value: '99_done',
    label: 'Pesanan Diterima',
    bChipsColor: 'green',
  },
];


const courierMethod = [
	{ title: '-', value: 'unknown' },
	{ title: 'Antar Sendiri', value: 'self_deliver' },
	{ title: 'Ambil Sendiri', value: 'self_pick_up' },
	{ title: 'Kurir Outlet', value: 'outlet_courier' },
	{ title: 'Kurir Instant', value: 'instant_courier' }
  ];

export { regex, jenisBayar, betaKeys, orderStatuses, courierMethod };
